module.exports = __webpack_public_path__ + "img/Diploma 01.bb65fa23.png";